import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import "./index.scss"

const AccountCover = ({ title, currentPath, activeColor }) => {
  return (
    <Fragment>
      <div className="account-cover">
        <p className="title">{title}</p>
        <div className="header">
          <nav className="app-breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="is-active">
                <a
                  href={currentPath}
                  aria-current="page"
                  style={{
                    color: activeColor,
                  }}
                >
                  {title}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Fragment>
  )
}

export default AccountCover
